<div fxLayout="column" class="no-select">
    @if (multiple) {
        <div class="p-8 radius-8" [class.bc-primary-gray-50]="!selectAllControl.value" [class.bc-primary-green-50]="selectAllControl.value">
            <ui-kit-checkbox [formControl]="selectAllControl">
                {{ 'i18n_lib_commonLabelSelectAll' | translate }}
            </ui-kit-checkbox>
        </div>
        <div class="mt-4 mb-16 p-8 radius-8" [class.bc-primary-gray-50]="!invertControl.value" [class.bc-primary-green-50]="invertControl.value">
            <ui-kit-checkbox (change)="onInvertChange()" [formControl]="invertControl">
                {{ 'i18n_lib_commonLabelInvertSelection' | translate }}
            </ui-kit-checkbox>
        </div>
    }

    <div fxLayout="column" class="selection-list-container" [class.expanded]="expanded" #list>
        @for (group of groups; track group) {
            <ui-kit-checkbox [formControl]="groupControlFor(group.label)">
                {{ group.label | translate }}
            </ui-kit-checkbox>
        }

        @for (item of items; track item) {
            <ui-kit-checkbox [formControl]="controlFor(item.label)">
                {{ item.label | translate }}
            </ui-kit-checkbox>
        }
    </div>

    @if (expanded || overflowing) {
        <ui-kit-button class="mt-16" type="text" size="small" buttonType="button"
                       [label]="(expanded ? 'i18n_lib_commonButtonHideAll' : 'i18n_lib_commonButtonShowAll') | translate: {amount: itemsCount}"
                       (clickListener)="toggleExpanded()"/>
    }
</div>
